import { ImageWraper } from '@components/shared/wraper/ImageWraper'
import { ProgramThumbnailGroupItem } from '@type/buzzkuri/program-detail'
import { cloudfrontPath } from '@utils/image'
import Link from 'next/link'

type Peops = ProgramThumbnailGroupItem

export const ProgramsSlideContentItem = ({
  id,
  imagePath,
  name,
  capacity,
}: Peops): JSX.Element => (
  <Link href={`/programs/${id}`}>
    <a className="hover:opacity-50">
      <div className="lg:w-[23.4vw]">
        <ImageWraper
          src={imagePath}
          width={300}
          height={150}
          alt={`${name}のイメージ画像`}
        />
      </div>
      <div className="lg:mt-[1.6vw]">
        <div className="lg:w-[23.4vw] lg:text-[1.4vw] font-bold lg:leading-[2.3vw] text-[#333333]">
          {name}
        </div>
      </div>
      <div className="flex flex-row items-center">
        <div className="lg:w-[0.6vw]">
          <ImageWraper
            src={`${cloudfrontPath}/programs/icons/program-category/entry_number_of_people.svg`}
            width={10}
            height={10}
          />
        </div>
        <div className="lg:ml-[0.6vw]">
          <div className="lg:text-[0.9vw] text-[#666666]">
            参加人数目安:{capacity}名
          </div>
        </div>
      </div>
    </a>
  </Link>
)
